import { useState } from 'react'

import { Location, PractitionerScheduleLocation } from '~/storm'

import { DatePractitionerCell } from '../../../shared'
import { LocationTag } from './LocationTag'

type Props = {
    selectedCells: DatePractitionerCell[]
    locations: Location[]
    practitionerScheduleLocations: PractitionerScheduleLocation[]
}

export const LocationTagsWithStaticState = ({ selectedCells, locations, practitionerScheduleLocations }: Props) => {
    const [initialLocationsState] = useState(() => locations)

    return (
        <>
            {initialLocationsState.map(location => (
                <LocationTag
                    key={location.uuid}
                    selectedCells={selectedCells}
                    location={location}
                    practitionerScheduleLocations={practitionerScheduleLocations}
                />
            ))}
        </>
    )
}
